import { C, GlassCard, Button, Badge } from "@coremonit/design-system";
import { CheckCircle2, Sparkles, ArrowRight } from "lucide-react";
import type { WizardData } from "../wizardStore";
import { StepHeader } from "./common";

interface Props { data: WizardData; onDone: () => void }

export function Step9Finish({ data, onDone }: Props) {
  return (
    <div>
      <StepHeader title="🎉 All set" description="Your service is registered and CoreMonit is now watching it." />
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
        <div style={{ width: 46, height: 46, borderRadius: 14, background: C.greenDim, border: `1px solid rgba(16,185,129,0.4)`, color: C.green, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 0 20px rgba(16,185,129,0.25)` }}>
          <CheckCircle2 size={22} />
        </div>
        <div>
          <div style={{ color: C.text, fontSize: 15, fontWeight: 700 }}>{data.name || "Service"} added</div>
          <div style={{ color: C.textMuted, fontSize: 11 }}>Environment: <Badge color="blue">{data.environment}</Badge> · Deployment: <Badge color="muted">{data.deploymentType}</Badge> · Instrumentation: {data.instrumentation.join(", ")}</div>
        </div>
      </div>

      <GlassCard style={{ padding: 18 }}>
        <div style={{ color: C.textSub, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 12 }}>Next steps</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          <NextTile title="Open the service" detail="See live metrics, traces, and logs already flowing in." onClick={onDone} />
          <NextTile title="Tune alerts"     detail="Confirm the AI-recommended thresholds match your SLO." />
          <NextTile title="Invite team"     detail="Give the on-call rotation the right access level." />
        </div>
      </GlassCard>
    </div>
  );
}

function NextTile({ title, detail, onClick }: { title: string; detail: string; onClick?: () => void }) {
  return (
    <button
      onClick={onClick}
      style={{
        textAlign: "left",
        padding: 12,
        background: C.surfaceHigh,
        border: `1px solid ${C.border}`,
        borderRadius: 12,
        cursor: onClick ? "pointer" : "default",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
        <Sparkles size={12} color={C.blue} />
        <div style={{ color: C.text, fontSize: 12, fontWeight: 700 }}>{title}</div>
        {onClick && <ArrowRight size={12} color={C.blue} style={{ marginLeft: "auto" }} />}
      </div>
      <div style={{ color: C.textMuted, fontSize: 10.5, lineHeight: 1.5 }}>{detail}</div>
    </button>
  );
}
